(() => {
  const roots = document.querySelectorAll('.lst');
  if (!roots.length) return;

  const revealNodes = document.querySelectorAll('.lst [data-lst-reveal]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const node = entry.target;
        const delay = Number(node.dataset.lstDelay || 0);
        if (delay > 0) node.style.transitionDelay = `${delay}ms`;
        node.classList.add('is-visible');
        observer.unobserve(node);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.01 });
    revealNodes.forEach((node) => observer.observe(node));
  }

  document.querySelectorAll('.lst [data-lst-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.lst-product__main-image');
    if (!main) return;
    gallery.querySelectorAll('[data-lst-media-src]').forEach((button) => {
      button.addEventListener('click', () => {
        main.src = button.dataset.lstMediaSrc;
        main.srcset = button.dataset.lstMediaSrcset || '';
        main.alt = button.dataset.lstMediaAlt || main.alt;
        gallery.querySelectorAll('[data-lst-media-src]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', String(active));
        });
      });
    });
  });

  const normalize = (value) => String(value || '').trim().toLowerCase();
  document.querySelectorAll('.lst[data-lst-product]').forEach((productRoot) => {
    const dataNode = productRoot.querySelector('[data-lst-variants]');
    let productData;
    try {
      productData = JSON.parse(dataNode?.textContent || '{}');
    } catch (_) {
      return;
    }
    if (!Array.isArray(productData.variants) || !productData.variants.length) return;

    const picker = productRoot.querySelector('variant-selects');
    const form = productRoot.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form?.querySelector('input[name="id"]');
    const submit = form?.querySelector('[name="add"]');
    const submitLabel = submit?.querySelector('span');
    if (!picker || !form || !idInput || !submit || !submitLabel) return;

    const optionNames = Array.isArray(productData.optionNames) ? productData.optionNames : [];
    const groups = () => Array.from(picker.querySelectorAll('.product-form__input'));
    const selectedValue = (group) => group.querySelector('input[type="radio"]:checked')?.value || group.querySelector('select')?.value || '';
    const findVariant = (values) => productData.variants.find((variant) => variant.options.every((option, index) => normalize(option) === normalize(values[index])));

    const optionValues = (index) => Array.from(new Set(productData.variants.map((variant) => variant.options[index]).filter(Boolean)));
    const looksLikeGender = (values) => values.length > 0 && values.every((value) => /^(m|w|men'?s?|women'?s?|male|female|unisex|ladies|man|woman|boys?|girls?)$/.test(normalize(value)));
    let genderIndex = optionNames.findIndex((name) => /gender|sex/.test(normalize(name)));
    let sizeIndex = optionNames.findIndex((name) => /shoe|size/.test(normalize(name)));
    if (genderIndex < 0) {
      genderIndex = optionNames.findIndex((_, index) => index !== sizeIndex && looksLikeGender(optionValues(index)));
    }
    if (sizeIndex < 0 && genderIndex >= 0 && optionNames.length === 2) sizeIndex = genderIndex === 0 ? 1 : 0;

    const setOptionVisibility = () => {
      const optionGroups = groups();
      if (genderIndex < 0 || sizeIndex < 0 || genderIndex === sizeIndex || optionGroups.length !== optionNames.length) return;
      const genderValue = selectedValue(optionGroups[genderIndex]);
      const allowed = new Map();
      productData.variants.forEach((variant) => {
        if (normalize(variant.options[genderIndex]) !== normalize(genderValue)) return;
        const size = normalize(variant.options[sizeIndex]);
        const state = allowed.get(size) || { available: false };
        state.available = state.available || variant.available;
        allowed.set(size, state);
      });

      const sizeGroup = optionGroups[sizeIndex];
      const radios = Array.from(sizeGroup.querySelectorAll('input[type="radio"]'));
      if (radios.length) {
        let firstExisting = null;
        let firstAvailable = null;
        radios.forEach((radio) => {
          const state = allowed.get(normalize(radio.value));
          const label = radio.labels?.[0] || sizeGroup.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
          const visible = state !== undefined;
          radio.disabled = !visible || !state.available;
          radio.classList.toggle('disabled', visible && !state.available);
          radio.hidden = !visible;
          if (label) {
            label.hidden = !visible;
            const unavailable = label.querySelector('.label-unavailable');
            if (unavailable) unavailable.hidden = !visible || state.available;
          }
          if (visible && !firstExisting) firstExisting = radio;
          if (visible && state.available && !firstAvailable) firstAvailable = radio;
        });
        const checked = radios.find((radio) => radio.checked);
        if (!checked || checked.hidden || !allowed.has(normalize(checked.value))) {
          const next = firstAvailable || firstExisting;
          if (next) {
            next.checked = true;
            next.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        return;
      }

      const select = sizeGroup.querySelector('select');
      if (select) {
        let firstExisting = null;
        let firstAvailable = null;
        Array.from(select.options).forEach((option) => {
          const state = allowed.get(normalize(option.value));
          option.hidden = !state;
          option.disabled = !state || !state.available;
          if (state && !firstExisting) firstExisting = option;
          if (state?.available && !firstAvailable) firstAvailable = option;
        });
        if (!allowed.has(normalize(select.value))) select.value = (firstAvailable || firstExisting)?.value || '';
      }
    };

    const update = () => {
      setOptionVisibility();
      const variant = findVariant(groups().map(selectedValue));
      idInput.value = variant ? String(variant.id) : '';
      idInput.disabled = !variant || !variant.available;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      submit.disabled = !variant || !variant.available;
      submitLabel.textContent = !variant
        ? (window.variantStrings?.unavailable || 'Unavailable')
        : variant.available
          ? (window.variantStrings?.addToCart || 'Add to cart')
          : (window.variantStrings?.soldOut || 'Sold out');

      const price = productRoot.querySelector('[data-lst-price]');
      const compare = productRoot.querySelector('[data-lst-compare]');
      if (price && variant) price.textContent = variant.priceFormatted;
      if (compare && variant) {
        compare.textContent = variant.compareAtFormatted || '';
        compare.hidden = !variant.compareAt || variant.compareAt <= variant.price;
      }

      const selectedJson = picker.querySelector('[data-selected-variant]');
      if (selectedJson) selectedJson.textContent = JSON.stringify(variant || null);
      const foxkit = productRoot.querySelector('foxkit-quantity-breaks');
      if (foxkit && variant) {
        foxkit.dataset.selectedVariantId = String(variant.id);
        foxkit.classList.toggle('soldout', !variant.available);
        const productJson = foxkit.querySelector('[data-product-json]');
        if (productJson) {
          try {
            const appData = JSON.parse(productJson.textContent);
            appData.selectedVariantId = String(variant.id);
            productJson.textContent = JSON.stringify(appData);
          } catch (_) {}
        }
        if (window.FoxkitEvents?.emit) window.FoxkitEvents.emit('ON_VARIANT_CHANGE', String(variant.id));
      }
    };

    update();
    picker.addEventListener('change', () => window.setTimeout(update, 0));
  });
})();
